export const initialValues: { [key: string]: { [key: string]: any } } = {
  companyName: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
      minLength: 3,
      maxLength: 150,
    },
  },
  role: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
      minLength: 3,
      maxLength: 150,
    },
  },
};

export const developmentTeamRoles = [
  'Architect',
  'General Contractor',
  'Civil Engineer',
  'Structural Engineer',
  'Corporate Legal Counsel',
  'Land Use Counsel',
];
